import { Layout } from '@/components/Layout';
import { ShipmentsBoard } from '@/components/logistics/ShipmentsBoard';

export default function LogisticsPortal() {
  return (
    <Layout>
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 lg:px-8" data-testid="logistics-portal">
        <div className="text-xs font-bold uppercase tracking-[0.25em] text-orange-600">Operador logístico</div>
        <h1 className="font-display text-3xl font-black tracking-tighter text-slate-900 mt-1">Mis recogidas y despachos</h1>
        <p className="mt-2 mb-5 text-sm text-slate-600">Programa la recogida, confirma que recogiste el paquete, registra la transportadora, la guía y el costo real, y actualiza la entrega.</p>
        <ShipmentsBoard isAdmin={false} />
      </div>
    </Layout>
  );
}
